"use client";

// Inicializa o Twind no cliente usando a API oficial v1 (@twind/core).
// "install" registra uma instância global e observa atributos class no DOM.
import { install } from "@twind/core";
import config from "../twind.config";

let installed = false;

export function ensureTwindInstalled() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  install(config as any);
}
